const fundraisingProgramTypes = [ 
  {
    id: 'FPT00',
    title: 'Project Finance / Export',
    index: 1,
    color: '#019644',
    parents: ['CPT00', 'CPT01', 'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT01',
    title: 'Direct Lending / Lombard lending / Lending',
    index: 2,
    color: '#019644',
    parents: ['CPT00'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT02',
    title: 'Préstamo Participativo',
    index: 3,
    color: '#019644',
    parents: ['CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT03',
    title: 'Deuda Senior, Subordinada, Bullet, Pik, Baloon, Etc.',
    index: 4,
    color: '#019644',
    parents: ['CPT00'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT04',
    title: 'Coinversión Estructurada en Minoría',
    index: 5,
    color: '#019644',
    parents: ['CPT00', 'CPT01',  'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT05',
    title: 'Coinversión Estructurada en Mayoría',
    index: 6,
    color: '#019644',
    parents: ['CPT00', 'CPT01', 'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT06',
    title: 'Coinversión en Solitario',
    index: 7,
    color: '#019644',
    parents: ['CPT00', 'CPT01', 'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT07',
    title: 'Estructuración Préstamo Sindicado',
    index: 8,
    color: '#019644',
    parents: ['CPT00'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT08',
    title: 'Préstamo Hipotecario',
    index: 9,
    color: '#019644',
    parents: ['CPT00'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT09',
    title: 'Pólizas Circulante, Confirming, Factoring, Etc.',
    index: 10,
    color: '#019644',
    parents: ['CPT00'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT10',
    title: 'Programas de Descuento de Pagarés, Facturas, Etc.',
    index: 11,
    color: '#019644',
    parents: ['CPT00'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT11',
    title:
      'Monetización de Contratos de pago o Anticipos de Otros Derechos Ciertos',
    index: 12,
    color: '#019644',
    parents: ['CPT00', 'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT12',
    title: 'Ampliaciones de Capital por Equity con Pacto de Socios',
    index: 13,
    color: '#019644',
    parents: ['CPT01'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT13',
    title: 'Programas de Lessores, Leasing, Leasebacks',
    index: 14,
    color: '#019644',
    parents: ['CPT00'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT14',
    title: 'Programas de Renting, Rentback, Etc',
    index: 15,
    color: '#019644',
    parents: ['CPT00'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT15',
    title: 'Emisión Programas Bonos Corporativos / Securitization',
    index: 16,
    color: '#019644',
    parents: ['CPT00', 'CPT01', 'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT16',
    title: 'Emisión programas Notas Corporativas / Securitization',
    index: 17,
    color: '#019644',
    parents: ['CPT00', 'CPT01', 'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT18',
    title: 'Programas de Equity con Pacto de Socios',
    index: 19,
    color: '#019644',
    parents: ['CPT01'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT20',
    title: 'Microfinanzas',
    index: 20,
    color: '#019644',
    parents: ['CPT00', 'CPT01', 'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT21',
    title: 'Islamic Finance, Sukuk, Vanilla derivatives',
    index: 21,
    color: '#019644',
    parents: ['CPT00', 'CPT01',  'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT22',
    title: 'Securitization of Cryptoactive tokenization programs',
    index: 22,
    helpKey: 'FPT22H',
    color: '#019644',
    parents: ['CPT02'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT23',
    title: 'Cryptocurrency capital Programs',
    index: 23,
    color: '#019644',
    parents: ['CPT02'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT24',
    title: 'Tokenizar Project Finance',
    index: 23,
    color: '#019644',
    helpKey: 'FPT24H',
    parents: ['CPT02'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT25',
    title: 'Direct Lending Tokens',
    index: 23,
    helpKey: 'FPT25H',
    color: '#019644',
    parents: ['CPT02'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT26',
    title: 'Garantía corporativa',
    index: 24,
    color: '#019644',
    parents: [],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  },
  {
    id: 'FPT19',
    title: 'Otros',
    index: 26,
    color: '#019644',
    parents: ['CPT00', 'CPT01', 'CPT02', 'CPT03'],
    colorFilterValues: {
      invert: '24',
      sepia: '95',
      saturate: '3296',
      hueRotate: '144',
      brightness: '101',
      contrast: '101'
    }
  }
]
export default fundraisingProgramTypes
